import L from "leaflet";
import "polyline-encoded";

function renderTripMap() {
  const mapContainer = document.querySelector("#trip-map");
  if(window.tripMap) {
  } else {
    const tripMap = L.map("trip-map");
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>',
    }).addTo(tripMap);

    window.tripMap = tripMap;
  }

  const polyline = mapContainer.dataset.polyline;
  const line = L.Polyline.fromEncoded(polyline);
  tripMap.fitBounds(line.getBounds());
  line.addTo(tripMap);

  const selectedStations = JSON.parse(mapContainer.dataset.selected);
  const candidateStations = JSON.parse(mapContainer.dataset.candidates);

  const allLocations = JSON.parse(mapContainer.dataset.allLocations);
  const radius = 5;

  const notCandidateIds = [...candidateStations.map((station) => station.id)];
  const notSelectedIds = [...selectedStations.map((station) => station.id)];
  const notAllLocationIds = [...notSelectedIds, ...notCandidateIds];

  candidateStations
    .filter((station) => !notSelectedIds.includes(station.id))
    .map((station) => {
      const circle = L.circleMarker([station.latitude, station.longitude], {
        color: "deeppink",
        fillColor: "deeppink",
        fillOpacity: 0.5,
        radius,
      });
      circle.bindPopup(
        `${station.name}, ${station.city}, ${station.state_code}`
      );
      return circle;
    })
    .forEach((circle) => {
      circle.addTo(tripMap);
    });

  selectedStations
    .map((station) => {
      const circle = L.circleMarker([station.latitude, station.longitude], {
        color: "darkblue",
        fillColor: "darkblue",
        fillOpacity: 0.5,
        radius,
      });

      circle.bindPopup(
        `${station.name}, ${station.city}, ${station.state_code}`
      );

      return circle;
    })
    .forEach((circle) => {
      circle.addTo(tripMap);
    });
}

window.renderTripMap = renderTripMap;

document.addEventListener("turbo:load", () => {
  if (!!document.querySelector("#trip-map")) {
    renderTripMap()
    window.tripMap.invalidateSize();
    window.tripMap.setZoom(5)
  }
});
